import { BaseComponent } from '../../base-component';
import { createLightbox } from '../../_common/client/nexus-interfaces/lightbox';

export class LightboxComponent extends BaseComponent {
    public rootSelector = '.js_pdp_lightbox';

    public async init(): Promise<void> {
        const { Lightbox } = await import('./lightbox/lightbox');
        createLightbox.assignFunction(options => {
            return Lightbox.initialize(options);
        });
    }
}
